import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import auth from './modules/auth'
import websocket from './modules/wss'
import backoffice from './backoffice/auth'
import user from './modules/user'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state:{
    counter: [],
    counterProductPromotionTabs: [],
    anonymousMessage : [],
    channels : [],
    selectedConversationId : "",
    conversations : [],
    firtOfChat : null,
    scrollToBottom : false,
    newElement : null,
    // CS-22992 — ข้อความเดิมที่ลูกค้าแก้ไขบน Messenger (ไม่ใช่ข้อความใหม่ ต้องแก้บับเบิลเดิมในที่)
    editedMessage : null,
    unRead : [],
    itemsPageDisconnected: [],
    showedPageDisconnected: false,
    messageTyping: [],
    chatUpdate: [],
    assignees: [],
    itemsPageUnlink: [],
    showedPageUnlinked: false,
    showedPageDeleted: false,
    callAPIDeletionPage: false,
    dataPageDeleted: null,
    itemsPageDeleted: [],
    tablePageDeleted: null,
  },
  mutations:{
    setCounter(state, counter){
      state.counter = counter
    },
    setProductPromotionTabs(state, counterProductPromotionTabs){
      state.counterProductPromotionTabs = counterProductPromotionTabs
    },
    setUnknownymousMessage(state, data) {
      state.anonymousMessage = data
    },
    addUnknowMessage(state, data){
      state.anonymousMessage.push(data)
    },
    setChannels(state, data) {
        state.channels = data
    },
    setSelectedConversationId(state, data) {
        state.selectedConversationId = data
    },
    setConversations(state, data) {
      data.forEach(v => {
        if (v.customer_image) v.customer_image = v.customer_image
        else v.customer_image = null
        delete v.customer_info_v2
        delete v.recent_messages
      });
      state.conversations = data
      // console.log(state.conversations)
    },
    setFirtOfChat(state, data) {
        state.firtOfChat = data
    },
    setNewElement(state, data) {
      state.newElement = data
    },
    setEditedMessage(state, data) {
      state.editedMessage = data
    },
    setUnRead(state, data) {
        state.unRead = data
    },
    setPageDisconnected(state, data) {
      state.itemsPageDisconnected = data
    },
    setShowedPageDisconnected(state, data) {
      state.showedPageDisconnected = data
    },
    setSendingMessage(state, data) {

      // const conversation =   state.conversations.find(({customer_id, page_id}) => customer_id == data.customer_id && page_id == data.page_id)
      const conversation = data.selectedChat;
      // console.log(data)
      const now = new Date().getTime()
 
      const {message, message_type, messageId, ...msgObj} = data

      if(state.anonymousMessage.find(({message_id}) => message_id == messageId)) return

      const objExam = {
        page_id: conversation.platform_page_id,
        customer_id: conversation.customer_platform_user_id,
        from: "page",
        type: message_type,
        message_id: messageId,
        message: message_type == "image" ? message.filter(p => p !== "loading") : message,
        is_sticker: message_type === 'sticker',
        is_like: false,
        is_has_emoji: false,
        timestamp: now,
        platform: conversation.platform,
        date: formatTimestampToHumanDate(now, 'date'),
        time: formatTimestampToHumanDate(now, 'time'),
        is_notify: false,
        readed : true,
        direction : "right",
        sended : false,
        send_success: false,
        send_raw_data : {
          ...msgObj,
          customer_name : conversation.customer_name
        },
        send_cnt : 0
      }
    
      store.dispatch("addUnknowMessageAction", objExam)
      
      //set conversation 
      store.dispatch("setConversationsAction", [...store.state.conversations].map(item => {
        if(item.customer_platform_user_id == conversation.customer_platform_user_id && item.platform_page_id == conversation.platform_page_id) {

          return {
            ...item,
            message_last : message,
            message_last_type : message_type,
            timestamp : now
          }
        }
        return item
      }))

      //set chat
      store.dispatch("setNewElementAction", unknowTomessage(objExam))

    },
    setSendedMessage(state, obj) {

      const {status, messageId} = obj
      var message = null
      var resendSuccess = false
      store.dispatch("anonymousMessageAction", [...state.anonymousMessage].map(item => {
        if(item.message_id === messageId) {
          item.send_success = status === 200
          item.sended = true


          item.send_cnt += 1
          //หากมีการมากกว่า 1 ครั้งแสดงว่าคือการ resent 
          if(item.send_cnt > 1 && item.send_success) {
            // เปลี่ยนเวลาของ message resent ให้เป็นล่าสุดเพราะไม่สามารถส่งย้อนหลังได้ :)
            const now = new Date().getTime()
            item.timestamp = now
            item.date = formatTimestampToHumanDate(now, 'date')
            item.time = formatTimestampToHumanDate(now, 'time')
            resendSuccess = true
          }

          item.done = (item.send_success && item.sended)
          message = item
        }
        return item
      }))

      const channelId = message.page_id
      const sendCnt = message.send_cnt

      message = unknowTomessage(message)

      if(status !== 200 && sendCnt > 1) {
        store.dispatch("setNewElementAction", {removeSpin : messageId})
        return
      } 

      store.dispatch("setNewElementAction", resendSuccess ? {...message, rmId : messageId} : message)

      if(status !== 200 || message === null) return

      // store.dispatch('websocket/sendMessageToChannel', {
      //   channel: channelId,
      //   message,
      //   event : `sended.message`,
      // });

      let data = {
        page_id: channelId,
        customer_id: message.send_raw_data.customer_id,
        user_id: state.auth.user._id,
        user_name: `${state.auth.user.first_name} ${state.auth.user.last_name}`,
        message,
        timestamp: message.timestamp
      };
      store.dispatch('websocket/sendMessageToChannels', {
        data: data,
        event: `message.sent`
      });
     
      store.dispatch("anonymousMessageAction", [...state.anonymousMessage].filter(({message_id}) => message_id != messageId))
    },
    clearReadedMessage(state, customerId = null){
      const pageIds = state.channels.map(({platform_page_id}) => platform_page_id)
      store.dispatch("anonymousMessageAction", [...state.anonymousMessage].filter(({done = null, customer_id, page_id}) => {
        if(customerId) {
          return !(customerId  == customer_id && done === true && pageIds.includes(page_id))
        }
        return !(done === true && pageIds.includes(page_id))
      }))
    },
    setAssignees(state, data) {
      state.assignees = data;
    },
    setMessageTyping(state, data) {
      state.messageTyping = data
    },
    setChatUpdate(state, data) {
      state.chatUpdate = data
    },
    setScrollToBottom(state) {
      state.scrollToBottom = !state.scrollToBottom
    },
    clearAllData(state) {
      state.counter = []
      state.counterProductPromotionTabs = []
      state.anonymousMessage = []
      state.channels = []
      state.selectedConversationId = ""
      state.conversations = []
      state.firtOfChat = null
      state.scrollToBottom = false
      state.newElement = null
      state.unRead = []
      state.itemsPageDisconnected = []
      state.showedPageDisconnected = false
      state.messageTyping = []
      state.chatUpdate = []
      state.assignees = []
    }
  },
  actions :{
      setNewElementAction(context, value) {
        context.commit('setNewElement', value)
      },
      setEditedMessageAction(context, value) {
        context.commit('setEditedMessage', value)
      },
      setUnReadAction(context, value) {
        context.commit('setUnRead', value)
      },
      setPageDisconnectedAction(context, value) {
        context.commit('setPageDisconnected', value)
      },
      setShowedPageDisconnectedAction(context, value) {
        context.commit('setShowedPageDisconnected', value)
      },
      setScrollToBottomAction(context){
        context.commit('setScrollToBottom')
      },
      anonymousMessageAction(context, value){
        context.commit('setUnknownymousMessage', value)
      },
      addUnknowMessageAction(context, value){
        context.commit('addUnknowMessage', value)
      },
      setChannelsAction(context, value){
        context.commit('setChannels', value)
      },
      setSelectedConversationIdAction(context, value){
        context.commit('setSelectedConversationId', value)
      },
      setConversationsAction(context, value){
        context.commit('setConversations', value)
      },
      setFirtOfChatAction(context, value){
        context.commit('setFirtOfChat', value)
      },
      setSendingMessageAction(context, value) {
        context.commit('setSendingMessage', value)
      },
      setSendedMessageAction(context, value) {
        context.commit('setSendedMessage', value)
      },
      clearReadedMessageAction(context, value) {
        context.commit('clearReadedMessage', value)
      },
      setTypingAction(context, value){
        context.commit('setAdminTypingItems', value)
      },
      setClearAllData(context, value){
        context.commit('clearAllData', value)
      },
      setMessageTypingAction(context, value){
        context.commit('setMessageTyping', value)
      },
      setChatUpdateAction(context, value){
        context.commit('setChatUpdate', value)
      },
      setAssigneesAction(context, value) {
        context.commit('setAssignees', value)
      }
  },
  getters:{
    counter:state=>state.counter,
    counterProductPromotionTabs:state=>state.counterProductPromotionTabs,
    anonymousMessage: state => groupCustomerPageId(state.anonymousMessage),
    unknownymousMessageToConversations: state =>  unknowToConversations(state.anonymousMessage),
  },

  modules: {
    auth,
    websocket,
    backoffice,
    user,
  },
  plugins: [createPersistedState({
    reducer: (state) => {
      const {newElement, messageTyping, chatUpdate, unRead, scrollToBottom, selectedConversationId, websocket, channels, ...data} = state
      return data
    }
  })]
})

const unknowToConversations = (msg) => {
  return groupCustomerPageId(msg)
  .filter(({pageId}) => store.state.channels.map(({platform_page_id}) => platform_page_id).includes(pageId))
  .map((item, index) => {

    const {name, logo} = store.state.channels.find(c => c.platform_page_id == item.pageId) || {
      name : "",
      logo : ""
    }

    const {cnt} = store.state.unRead.find(({key}) => key === `${item.customerId}--${item.pageId}`) || {cnt : 0}

    return {
      id: `chat_unknownymous_${index++}`,
      page_id: item.pageId,
      platform_page_id : item.pageId,
      customer_id: item.customerId,
      sender_id: item.customerId,
      unread_message_count: 0,
      unread_cnt : cnt,
      merchant_id: "",
      integration_name: item.platform,
      page_name: name,
      page_status: "",
      page_is_connected: true,
      is_confirm_integration: true,
      customer_name: "",
      customer_platform_user_id : item.customerId,
      message_id : item.message.messageId,
      message_last: item.message.at(-1).message,
      message_last_type: item.message.at(-1).type,
      messages : item.message,
      mark_as_status: "",
      assignee: null,
      order_status: "",
      chat_status: cnt ? "UNREAD" : "READ",
      tags: [],
      chat_room_id: "",
      isImportant: 0,
      customer_image: "",
      from : item.from,
      page_image: logo,
      date: item.message.at(-1).date,
      time: item.message.at(-1).time,
      timestamp: item.timestamp,
      platform: item.platform,
      send_raw_data : item.send_raw_data || {}
    }
  })
}

export const unknowTomessage = (unknowMsg, list = false) => {
  let conversationz = unknowToConversations(list ? unknowMsg  : [unknowMsg] )[0]
  
  conversationz =  conversationz.messages.map(item => ({
      _id : item.messageId,
      page_id : conversationz.page_id,
      message_type : item.type,
      message : item.message,
      customer_id : conversationz.customer_id,
      customer_platform_user_id : conversationz.customer_id,
      sender_id : item.direction == 'right' ? [...conversationz.customer_id].reverse().join("") : conversationz.customer_id,
      is_notify : item.is_notify,
      status : "ACTIVE",
      customer_name : "",
      sender_name : item.direction == 'right' ? item.send_raw_data.sender_name : "",
      sender_image : item.direction == 'right' ? item.send_raw_data.sender_profile : "",
      datetime : `${item.date} ${item.time}`,
      datetime_sort : `${item.date} ${item.time}`,
      is_sticker : item.is_sticker || (item.option && item.option.sticker),
      is_like : item.is_like || (item.option && item.option.like),
      is_has_emoji : item.is_has_emoji || (item.option && item.option.emoticon),
      sticker_type : "",
      integration_name : conversationz.platform,
      timestamp : item.timestamp,
      send_raw_data : item.send_raw_data,
      sended : item.sended,
      send_success : item.send_success,
      send_cnt : item.send_cnt,
      from : item.from
  }))
  
  return list ? conversationz : conversationz[0]
}

const groupCustomerPageId = (arr) => {
  const initialValue = new Map();

  return Array.from(arr.reduce((acc, cval) => {
    const { 
      date, message, timestamp, type, time, 
      from, customer_id, page_id, platform, 
      readed, option, message_id, is_like, is_sticker, 
      is_has_emoji, is_notify, sended, send_raw_data,
      direction, send_success, send_cnt, unreadCnt
    } = cval
    const combinedKey = `${page_id}_${customer_id}`;

    if (!acc.has(combinedKey)) {
      acc.set(combinedKey, {
        message : [], 
        platform, 
        pageId : page_id, 
        customerId : customer_id, 
        timestamp
      });
    }
    acc.get(combinedKey).message.push({
      message, 
      type, 
      timestamp, 
      date, 
      time, 
      readed, 
      messageId : message_id, 
      option,
      is_like, 
      is_sticker, 
      is_notify,
      is_has_emoji,
      sended,
      send_success,
      send_cnt,
      send_raw_data,
      direction,
      from,
      unreadCnt
    })
    acc.get(combinedKey).timestamp = +timestamp
    return acc;
  }, initialValue), ([key, value]) => ( value )).sort((a, b) => b.timestamp - a.timestamp)
};

export const isSelectedConversation = (customerId, pageId, selectedConversationId) => {
  if(!selectedConversationId) return false

  const [customer_id, page_id] = selectedConversationId.split("|#|")

  return customer_id == customerId && page_id == pageId
}

export const formatTimestampToHumanDate = (timestamp, type) => {
  const date = new Date(+timestamp);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); 
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const hoursminusseven = String(date.getHours() - 7).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  const milliseconds = String(date.getMilliseconds());
  const ampm = date.getHours() >= 12 ? 'pm' : 'am';

  if(type === 'date') {
    return `${year}-${month}-${day}`;
  }
  
  if(type === 'time') {
    return `${hours}:${minutes}:${seconds}.${milliseconds}`;
  }

  if(type === 'ampm') {
    return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
  }

  if(type === 'datetime') {
    return `${year}-${month}-${day}T${hoursminusseven}:${minutes}:${seconds}.${milliseconds}Z`;
  }
}



// WEBPACK FOOTER //
// ./src/vuex-store/index.js